import LegalDocument from "../components/LegalDocument";
import contentContributorContent from "../content/contentContributorAgreement";

export default function ContentContributorAgreement() {
  return (
    <LegalDocument
      pageTitle="Content Contributor Agreement"
      content={contentContributorContent}
    />
  );
}
